module.exports = __webpack_public_path__ + "img/38.8c031c6e.jpg";